import makeList from './makeList.js'

let viewFloor = 'west'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: '防火区画C前',
        file: './data/02_R0010754.JPG',
        rotation: -20,
        link: [
          {
            file: './data/01b_R0010752.JPG',
            position: [ 4835.581209284954, -390.5574912935128, 1186.1992366548393 ],
          },
          {
            file: './data/05_R0010756.JPG',
            position: [ 3489.516273554356, -317.9923949195835, 3554.216055384322 ],
          },
          {
            file: './data/03_R0010658.JPG',
            position: [ -4843.418278331411, -268.1694244580455, 1175.5042006872811 ],
          },
          {
            file: './data/17b_R0010660.JPG',
            position: [ -2696.4692513188916, -356.1586235832855, -4185.875862869486 ],
          },
        ],
        info: [
          {
            name: 'firewall',
            position: [ 4909.055328049801, 299.81370557002975, -848.709806987573 ],
          },
        ],
        view: {
          syowa: [ 701.5590200445434, 458.79732739420933 ],
          syowaZoom: [ 505.5679287305122, 535.71714922049 ],
        },
      },
      { description: '19広場脇',
        file: './data/01b_R0010752.JPG',
        rotation: 0,
        link: [
          {
            file: './data/01_R0010753.JPG',
            position: [ 4763.225243332561, -508.1886728730788, 1403.0461472289549 ],
          },
          {
            file: './data/05_R0010756.JPG',
            position: [ -2168.448867709216, -159.05585126450066, 4492.0564971808635 ],
          },
          {
            file: './data/02_R0010754.JPG',
            position: [ -4967.929625730013, -10.933289614648293, -549.4468779796053 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 648.1069042316258, 449.8886414253897 ],
          syowaZoom: [ 391.98218262806233, 537.9443207126949 ],
        },
      },
      { description: '旧主屋棟周辺',
        file: './data/01_R0010753.JPG',
        rotation: -60,
        link: [
          {
            file: './data/01b_R0010752.JPG',
            position: [ -4946.375295340268, 208.77662937112436, -635.9141607156815 ],
          },
        ],
        info: [
          { name: 'oldCentral',
            position: [ 2635.842275052757, -368.8867936468958, -4224.652052927473 ],
          },
        ],
        view: {
          syowa: [ 601.3363028953229, 447.66146993318483 ],
          syowaZoom: [ 300.12771392081737, 537.7765006385696 ],
        },
      },
      { description: '基本観測棟前',
        file: './data/03_R0010658.JPG',
        rotation: -100,
        link: [
          {
            file: './data/04_R0010655.JPG',
            position: [ -4870.922365297279, -29.762038535662988, 1108.9989218559647 ],
          },
          {
            file: './data/I10.JPG',
            position: [ -1769.8776402962158, -28.19028742834937, -4667.807964690968 ],
          },
          {
            file: './data/17b_R0010660.JPG',
            position: [ 1353.2559762159306, -423.6568738192807, -4786.910263713144 ],
          },
          {
            file: './data/02_R0010754.JPG',
            position: [ 4904.382927631568, -424.38609329536706, -830.7683437825892 ],
          },
        ],
        info: [
          {
            name: 'mainObservatory',
            position: [ -377.34561937165347, 862.7879575910144, 4902.630329211713 ],
          },
        ],
        view: {
          syowa: [ 777.28285077951, 443.20712694877506 ],
          syowaZoom: [ 610.4725415070243, 533.9450830140486 ],
        },
      },
      { description: '旧放球棟前',
        file: './data/04_R0010655.JPG',
        rotation: 160,
        link: [
          {
            file: './data/03_R0010658.JPG',
            position: [ 4118.560048906062, -129.55135286522278, -2816.4514716346557 ],
          },
          {
            file: './data/04c_R0010657.JPG',
            position: [ 2732.3010020228508, -1034.446823909648, 4046.218198907622 ],
          },
          {
            file: './data/I19a.JPG',
            position: [ 2924.454462231247, -161.86089404102444, 4046.9105248311234 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 826.2806236080178, 494.4320712694878 ],
          syowaZoom: [ 714.9220489977728, 609.2138084632516 ],
        },
      },
      { description: '19広場',
        file: './data/05_R0010756.JPG',
        rotation: -20,
        link: [
          {
            file: './data/01b_R0010752.JPG',
            position: [ 443.24036959819375, -1028.6476764846022, -4866.185351410603 ],
          },
          {
            file: './data/02_R0010754.JPG',
            position: [ -4308.360468770887, -405.66914992424586, -2502.354002770901 ],
          },
          {
            file: './data/06_R0010758.JPG',
            position: [ 830.7692612727753, -508.0356852362734, 4894.372496167087 ],
          },
        ],
        info: [
          {
            name: '19',
            position: [ 4782.509234484735, -992.8943707896404, -1044.230459115198 ],
          },
        ],
        view: {
          syowa: [ 648.1069042316258, 494.4320712694878 ],
          syowaZoom: [ 391.98218262806233, 598.0779510022271 ],
        },
      },
      { description: '汚水処理棟前',
        file: './data/06_R0010758.JPG',
        rotation: 30.313968694929805,
        link: [
          {
            file: './data/I51a.JPG',
            position: [ -1433.562214083288, -1246.0711569575935, 4619.347775186096 ],
          },
          {
            file: './data/05_R0010756.JPG',
            position: [ -1199.2749144777804, 290.76004400268414, -4836.131451322144 ],
          },
          {
            file: './data/07_R0010670.JPG',
            position: [ 2512.3829428350437, 1.9502436014807258, -4321.994137091663 ],
          },
          {
            file: './data/08_R0010759.JPG',
            position: [ 4293.581420717558, -99.58222118648854, -2549.101206929652 ],
          },
        ],
        info: [
          {
            name: 'sewage',
            position: [ -4831.4421226406475, 228.11247750899537, -1226.2721280814983 ],
          },
        ],
        view: {
          syowa: [ 612.4721603563474, 559.0200445434298 ],
          syowaZoom: [ 298.44097995545656, 745.0712694877504 ],
        },
      },
      { description: '福島ケルン正面',
        file: './data/I51a.JPG',
        rotation: 10,
        link: [
          {
            file: './data/I51b.JPG',
            position: [ 4755.904456134199, -291.1335047096834, 1498.629010582369 ],
          },
          {
            file: './data/06_R0010758.JPG',
            position: [ -38.81123710226871, 67.15429869036224, -4995.327440548883 ],
          },
        ],
        info: [
          {
            name: 'kerun',
            position: [ 4929.318436902618, 391.1673396924719, 697.8612119006932 ],
          },
          {
            name: 'keunZoom1',
            position: [ 4929.481537425069, -467.92761551632134, 639.4034141116448 ],
          },
          {
            name: 'keunZoom2',
            position: [ 4783.587755968884, 170.44698615081273, -1413.609675443911 ],
          },
        ],
        view: {
          syowa: [ 620.5128205128206, 610.2564102564103 ],
          syowaZoom: [ 329.62138084632517, 825.2494432071269 ],
        },
      },
      { description: '福島ケルン裏',
        file: './data/I51b.JPG',
        rotation: 180,
        link: [
          {
            file: './data/I51a.JPG',
            position: [ -4918.033513793324, -101.43795712260446, 841.7786379945356 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 569.2307692307693, 605.1282051282052 ],
          syowaZoom: [ 249.04214559386975, 830.2413793103449 ],
        },
      },
      { description: '燃料タンク海側',
        file: './data/08_R0010759.JPG',
        rotation: 0,
        link: [
          {
            file: './data/06_R0010758.JPG',
            position: [ -4888.202109116524, -215.32505797275803, 1001.5624288738911 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 496.65924276169267, 581.2917594654788 ],
          syowaZoom: [ 106.9042316258352, 765.1158129175947 ],
        },
      },
      { description: '燃料タンク陸側',
        file: './data/07_R0010670.JPG',
        rotation: 90,
        link: [
          {
            file: './data/06_R0010758.JPG',
            position: [ -4125.969199895645, -246.89153616105227, 2796.5890265508638 ],
          },
          {
            file: './data/09_R0010761.JPG',
            position: [ 3550.541578135588, -28.32214658992721, -3509.264070390821 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 521.1581291759466, 501.11358574610244 ],
          syowaZoom: [ 171.49220489977728, 640.3942093541202 ],
        },
      },
      { description: '管理棟下',
        file: './data/09_R0010761.JPG',
        rotation: 200,
        link: [
          {
            file: './data/10_R0010762.JPG',
            position: [ 1866.2594286563578, -163.11300540396405, -4625.139823552624 ],
          },
          {
            file: './data/07_R0010670.JPG',
            position: [ -474.11053088269057, -268.9384721712591, 4964.586351922723 ],
          },
          {
            file: './data/I18b_1.JPG',
            position: [ -4659.74910136461, 317.51426171971, 1759.1945881915717 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 503.34075723830733, 432.07126948775056 ],
          syowaZoom: [ 124.72160356347439, 502.30957683741644 ],
        },
      },
      { description: '130kℓ水槽前',
        file: './data/14_R0010763.JPG',
        rotation: 70,
        link: [
          {
            file: './data/15_R0010764.JPG',
            position: [ -4201.030141207507, -476.7065617725434, 2652.2118487575867 ],
          },
          {
            file: './data/10_R0010762.JPG',
            position: [ 4969.860078686851, -493.91736136334714, 51.49537776691506 ],
          },
        ],
        info: [
          {
            name: '130l',
            position: [ 367.34826255439185, -1788.2577266949813, 4646.3196169126595 ],
          },
        ],
        view: {
          syowa: [ 525.6124721603563, 338.5300668151448 ],
          syowaZoom: [ 162.5835189309577, 317.4543429844098 ],
        },
      },
      { description: '倉庫棟・発電棟周辺',
        file: './data/15_R0010764.JPG',
        rotation: 135,
        link: [
          {
            file: './data/14_R0010763.JPG',
            position: [ 3386.8492054120316, -676.6289179722812, -3605.232546451997 ],
          },
          {
            file: './data/I57e_2PB303.JPG',
            position: [ -4252.985713543392, -166.5196352510527, 2606.790876158579 ],
          },
          {
            file: './data/I57h_SM60.JPG',
            position: [ -3669.0684918902502, 370.153371394029, -3371.769511346301 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 590.2004454342984, 358.57461024498883 ],
          syowaZoom: [ 240.53452115812917, 375.3608017817371 ],
        },
      },
      { description: '2居・倉庫棟間PB303後部',
        file: './data/I57e_2PB303.JPG',
        rotation: 90,
        link: [
          {
            file: './data/I57g_2PB303.JPG',
            position: [ 1318.1624580841426, 190.43283288209514, 4808.350960602688 ],
          },
          {
            file: './data/17_R0010661.JPG',
            position: [ -4079.8319951753115, 217.98454679719688, -2869.716606486929 ],
          },
          {
            file: './data/15_R0010764.JPG',
            position: [ 4168.576285782094, -351.1042524769379, -2723.472365124668 ],
          },
        ],
        info: [
          {
            name: 'food',
            position: [ 3789.9754704264715, 708.8995178292026, 3170.0387214594557 ],
          },
        ],
        view: {
          syowa: [ 645.8797327394209, 425.38975501113583 ],
          syowaZoom: [ 393.35887611749683, 436.88250319284793 ],
        },
      },
      { description: 'PB303内部',
        file: './data/I57g_2PB303.JPG',
        rotation: 45,
        link: [
          {
            file: './data/I57f_2PB303.JPG',
            position: [ 3433.3043469530176, -1763.1353790168157, 3168.8567181295516 ],
          },
          {
            file: './data/I57e_2PB303.JPG',
            position: [ -2526.8472158700547, -1025.3964661152281, -4181.7851535669915 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 658.1291759465478, 416.4810690423162 ],
          syowaZoom: [ 374.8403575989783, 450.2924648786717 ],
        },
      },
      { description: '2居・倉庫棟間PB303前部',
        file: './data/I57f_2PB303.JPG',
        rotation: -130,
        link: [
          {
            file: './data/I57g_2PB303.JPG',
            position: [ -3297.216503056719, 1119.7097679580777, -3582.4026655491257 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 670.3786191536748, 407.57238307349667 ],
          syowaZoom: [ 356.32183908045977, 463.70242656449545 ],
        },
      },
      { description: '1居・2居間',
        file: './data/17_R0010661.JPG',
        rotation: -90,
        link: [
          {
            file: './data/I57e_2PB303.JPG',
            position: [ 4350.988885191641, -644.9292062851065, 2359.37943881767 ],
          },
          {
            file: './data/17b_R0010660.JPG',
            position: [ -3966.9884891115757, -268.9081125581307, 3018.6016876803637 ],
          },
          {
            file: './data/I57a_SM415.JPG',
            position: [ -714.0248746892682, 59.99544863358854, -4939.914020870664 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 721.6035634743876, 360.8017817371938 ],
          syowaZoom: [ 523.3853006681514, 357.543429844098 ],
        },
      },
      { description: '第1居住棟脇',
        file: './data/17b_R0010660.JPG',
        rotation: 150,
        link: [
          {
            file: './data/02_R0010754.JPG',
            position: [ 3374.3771856837834, -188.86581000383552, 3676.5201623709113 ],
          },
          {
            file: './data/03_R0010658.JPG',
            position: [ -1111.6990551404745, -176.11517350408877, 4864.254123598377 ],
          },
          {
            file: './data/I10.JPG',
            position: [ -2749.1714239363127, -97.90016038864212, -4163.732989891147 ],
          },
          {
            file: './data/17_R0010661.JPG',
            position: [ 2786.7331010643998, -446.70014665304103, -4117.899811489116 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 748.3296213808463, 412.02672605790644 ],
          syowaZoom: [ 565.7015590200446, 459.99331848552333 ],
        },
      },
      { description: '地学棟前',
        file: './data/I10.JPG',
        rotation: -110,
        link: [
          {
            file: './data/17b_R0010660.JPG',
            position: [ 4491.186713425965, -110.99981133851648, 2174.30912406101 ],
          },
          {
            file: './data/03_R0010658.JPG',
            position: [ 2512.118054603753, 53.37061654689995, 4319.760529194988 ],
          },
          {
            file: './data/I10f.JPG',
            position: [ -275.56530236728844, 2047.7193342144567, -4543.041835452719 ],
          },
        ],
        info: [
          { name: 'cycle',
            position: [ -1151.4140616603847, -163.25408150404033, -4854.134829976198 ],
          },
        ],
        view: {
          syowa: [ 818.6874304783091, 384.87208008898773 ],
          syowaZoom: [ 683.7416481069042, 384.26948775055666 ],
        },
      },
      { description: '自然エネルギー棟前',
        file: './data/I57a_SM415.JPG',
        rotation: -70,
        link: [
          {
            file: './data/I57c_SM415.JPG',
            position: [ 2233.7055229558127, 236.8745715087844, -4455.379783923732 ],
          },
          {
            file: './data/21_R0010767.JPG',
            position: [ 4928.141559598384, 658.9012606408165, -474.9328115962274 ],
          },
          {
            file: './data/17_R0010661.JPG',
            position: [ 1490.5323675984005, -411.4717331274414, 4751.618161054736 ],
          },
          {
            file: './data/19_R0010768.JPG',
            position: [ -3686.648238961866, -154.50203360416674, -3366.155897806885 ],
          },
        ],
        info: [
          {
            name: 'natural',
            position: [ -3297.7752878253004, 130.23698985978228, 3747.919440334566 ],
          },
        ],
        view: {
          syowa: [ 741.6481069042317, 305.1224944320713 ],
          syowaZoom: [ 530.0668151447661, 301.86414253897556 ],
        },
      },
      { description: 'SM415内部',
        file: './data/I57c_SM415.JPG',
        rotation: 0,
        link: [
          {
            file: './data/I57a_SM415.JPG',
            position: [ -288.4992217543812, -648.6694192549195, 4939.123307573052 ],
          },
          {
            file: './data/I57b_SM415.JPG',
            position: [ 314.40009352815616, -1373.7297154975067, -4787.1327326397395 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 730.5122494432071, 273.94209354120267 ],
          syowaZoom: [ 512.2494432071269, 243.9576837416481 ],
        },
      },
      { description: 'SM415後部',
        file: './data/I57b_SM415.JPG',
        rotation: 70,
        link: [
          {
            file: './data/I57c_SM415.JPG',
            position: [ 2302.202113911428, -152.36759024151806, 4424.200349469818 ],
          },
          {
            file: './data/I9.JPG',
            position: [ -4367.826324330159, 1.2927052842408162, -2425.899044851878 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 746.1024498886414, 251.67037861915367 ],
          syowaZoom: [ 530.0668151447661, 199.4142538975501 ],
        },
      },
      { description: '焼却炉棟前',
        file: './data/19_R0010768.JPG',
        rotation: 150,
        link: [
          {
            file: './data/I57a_SM415.JPG',
            position: [ 3716.9279411277134, -417.20961276324573, 3315.028811262345 ],
          },
          {
            file: './data/I9.JPG',
            position: [ 4956.224285247429, -507.5474887234842, 280.90336461313836 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 837.4164810690423, 267.26057906458794 ],
          syowaZoom: [ 730.5122494432071, 192.73273942093545 ],
        },
      },
      { description: '電離層棟入口',
        file: './data/I9.JPG',
        rotation: -60,
        link: [
          {
            file: './data/I57b_SM415.JPG',
            position: [ 4838.952730303891, -211.652374521517, 1200.7381367715304 ],
          },
          {
            file: './data/19_R0010768.JPG',
            position: [ -4796.908767702365, -253.28209416761155, 1351.3365877885558 ],
          },
          {
            file: './data/I9e.JPG',
            position: [ 1703.9368654087127, 1446.2683638103215, -4462.347503748269 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 792.8730512249443, 256.12472160356344 ],
          syowaZoom: [ 659.2427616926503, 174.91536748329622 ],
        },
      },
      { description: '天測点',
        file: './data/21_R0010767.JPG',
        rotation: 40,
        link: [
          {
            file: './data/I57i_SM60.JPG',
            position: [ 3222.990189965884, -1173.787015100778, 3635.154335969902 ],
          },
          {
            file: './data/I57a_SM415.JPG',
            position: [ -3924.1690685250696, -842.0829116114083, 2971.6515338100935 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 668.1514476614699, 242.76169265033406 ],
          syowaZoom: [ 416.4810690423163, 148.18930957683745 ],
        },
      },
      { description: 'SM60後部',
        file: './data/I57i_SM60.JPG',
        rotation: 50,
        link: [
          {
            file: './data/21_R0010767.JPG',
            position: [ -1850.3940895960632, 588.3485738869905, -4596.776942565893 ],
          },
          {
            file: './data/I57j_SM60.JPG',
            position: [ 3271.2008377372254, -301.8756974446708, 3760.7733872830436 ],
          },
          {
            file: './data/I57h_SM60.JPG',
            position: [ 3872.721952400006, -821.9791462418846, 3041.528954723024 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 648.1069042316258, 307.34966592427617 ],
          syowaZoom: [ 409.79955456570156, 279.59242761692644 ],
        },
      },
      { description: 'SM60内部',
        file: './data/I57j_SM60.JPG',
        rotation: -120,
        link: [
          {
            file: './data/I57h_SM60.JPG',
            position: [ 2111.779640291441, -1574.0273187828107, 4241.691742631552 ],
          },
          {
            file: './data/I57i_SM60.JPG',
            position: [ 2111.779640291441, -1574.0273187828107, 4241.691742631552 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 645.8797327394209, 329.62138084632517 ],
          syowaZoom: [ 385.30066815144767, 310.7728285077951 ],
        },
      },
      { description: 'SM60前部',
        file: './data/I57h_SM60.JPG',
        rotation: -90,
        link: [
          {
            file: './data/I57i_SM60.JPG',
            position: [ -2367.6584535645306, 406.72641627656236, -4378.369053418103 ],
          },
          {
            file: './data/I57j_SM60.JPG',
            position: [ -3336.7406999376562, 728.9657375429259, -3646.592715545793 ],
          },
          {
            file: './data/15_R0010764.JPG',
            position: [ 1766.9273131556404, -1153.3196961535161, 4525.30789829579 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 643.652561247216, 351.89309576837417 ],
          syowaZoom: [ 349.6659242761693, 339.72605790645866 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
